import React, { useState, useEffect } from 'react';
import { FiGitBranch, FiEye } from 'react-icons/fi';
import Table from '../../../../app/components/Table';
import RecorrentOffCanvas from './RecorrentOffCanvas';
import Pagination from '../../../../app/components/Pagination';
import Input from '../../../../app/components/Input';
import Loader from '../../../../app/components/Loader';
import { usePageTitle } from '../../../../contexts/PageTitleContext';


const Recorrentes = () => {
    const { setTitle } = usePageTitle();

    useEffect(() => {
    setTitle('Tarefas Recorrentes');
    }, [setTitle]); 
    
    const [tarefas, setTarefas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');

    const colunas = [
        { campo: 'obrigacao_nome', titulo: 'Obrigação' },
        { campo: 'razao_social', titulo: 'EMPRESA' },
        { campo: 'prazo_legal', titulo: 'Competência' },
        { campo: 'status', titulo: 'Prazo Legal', tipo: 'status' },
        { campo: 'competencia', titulo: 'Leituras' },
        { campo: 'responsavel_nome', titulo: 'Status' },
        { campo: 'nome_departamento', titulo: 'Responsável' },
        { campo: 'acoes', titulo: 'AÇÕES', tipo: 'acoes', centralizado: true },
    ];
    const [selectedTarefa, setSelectedTarefa] = useState(null);

    const mockTarefas = [
        {
            id: 1,
            obrigacao_nome: 'Entregar Relatório Mensal',
            razao_social: 'Empresa ABC Ltda',
            prazo_legal: '2025-06-30',
            status: 'Pendente',
            competencia: '2025-06-01',
            responsavel_nome: 'João Silva',
            responsavel_foto: '',
            nome_departamento: 'Contabilidade'
        },
        {
            id: 2,
            obrigacao_nome: 'Pagamento de Impostos',
            razao_social: 'Empresa XYZ S.A.',
            prazo_legal: '2025-06-25',
            status: 'Entregue',
            competencia: '2025-06-01',
            responsavel_nome: 'Maria Oliveira',
            responsavel_foto: '',
            nome_departamento: 'Financeiro'
        },
        {
            id: 3,
            obrigacao_nome: 'Atualização de Cadastro',
            razao_social: 'Empresa ABC Ltda',
            prazo_legal: '2025-07-10',
            status: 'Pendente',
            competencia: '2025-07-01',
            responsavel_nome: 'Carlos Souza',
            responsavel_foto: '',
            nome_departamento: 'Administrativo'
        },
        {
            id: 4,
            obrigacao_nome: 'Envio de Demonstrativo Fiscal',
            razao_social: 'Empresa XYZ S.A.',
            prazo_legal: '2025-06-28',
            status: 'Pendente',
            competencia: '2025-06-01',
            responsavel_nome: 'Ana Pereira',
            responsavel_foto: '',
            nome_departamento: 'Contabilidade'
        },
        {
            id: 5,
            obrigacao_nome: 'Renovação de Licença',
            razao_social: 'Empresa 123 Ltda',
            prazo_legal: '2025-07-15',
            status: 'Entregue',
            competencia: '2025-07-01',
            responsavel_nome: 'Paulo Mendes',
            responsavel_foto: '',
            nome_departamento: 'Jurídico'
        },
        {
            id: 6,
            obrigacao_nome: 'Auditoria Interna',
            razao_social: 'Empresa 123 Ltda',
            prazo_legal: '2025-07-05',
            status: 'Pendente',
            competencia: '2025-07-01',
            responsavel_nome: 'Fernanda Lima',
            responsavel_foto: '',
            nome_departamento: 'Compliance'
        },
        {
            id: 7,
            obrigacao_nome: 'Pagamento de Fornecedores',
            razao_social: 'Empresa ABC Ltda',
            prazo_legal: '2025-06-29',
            status: 'Entregue',
            competencia: '2025-06-01',
            responsavel_nome: 'Roberto Costa',
            responsavel_foto: '',
            nome_departamento: 'Financeiro'
        },
        {
            id: 8,
            obrigacao_nome: 'Envio de Relatório Anual',
            razao_social: 'Empresa XYZ S.A.',
            prazo_legal: '2025-12-31',
            status: 'Pendente',
            competencia: '2025-12-01',
            responsavel_nome: 'Luciana Silva',
            responsavel_foto: '',
            nome_departamento: 'Contabilidade'
        },
        {
            id: 9,
            obrigacao_nome: 'Atualização de Software',
            razao_social: 'Empresa 123 Ltda',
            prazo_legal: '2025-07-20',
            status: 'Pendente',
            competencia: '2025-07-01',
            responsavel_nome: 'Marcelo Santos',
            responsavel_foto: '',
            nome_departamento: 'TI'
        },
        {
            id: 10,
            obrigacao_nome: 'Reunião de Planejamento',
            razao_social: 'Empresa ABC Ltda',
            prazo_legal: '2025-06-27',
            status: 'Pendente',
            competencia: '2025-06-01',
            responsavel_nome: 'Cristina Oliveira',
            responsavel_foto: '',
            nome_departamento: 'Gestão'
        },
        {
            id: 11,
            obrigacao_nome: 'Entrega de Documentação',
            razao_social: 'Empresa XYZ S.A.',
            prazo_legal: '2025-07-08',
            status: 'Pendente',
            competencia: '2025-07-01',
            responsavel_nome: 'Pedro Almeida',
            responsavel_foto: '',
            nome_departamento: 'Administrativo'
        },
        {
            id: 12,
            obrigacao_nome: 'Renovação de Contrato',
            razao_social: 'Empresa 123 Ltda',
            prazo_legal: '2025-07-25',
            status: 'Pendente',
            competencia: '2025-07-01',
            responsavel_nome: 'Amanda Ribeiro',
            responsavel_foto: '',
            nome_departamento: 'Jurídico'
        }
    ];


    useEffect(() => {
        RecorrentOffCanvas.init();
        
        const timer = setTimeout(() => {
            fetchTarefas();
        }, 500);
        
        return () => clearTimeout(timer);
    }, [currentPage, pageSize, searchTerm]);

    const handleOpenOffCanvas = (tarefa) => {
        setSelectedTarefa(tarefa);
        RecorrentOffCanvas.open(tarefa);
    };

    const fetchTarefas = () => {
        setLoading(true);
        try {
            let filteredData = [...mockTarefas];
            
            if (searchTerm) {
                const term = searchTerm.toLowerCase();
                filteredData = filteredData.filter(tarefa => 
                    tarefa.obrigacao_nome.toLowerCase().includes(term) ||
                    tarefa.razao_social.toLowerCase().includes(term) ||
                    tarefa.responsavel_nome.toLowerCase().includes(term) ||
                    tarefa.nome_departamento.toLowerCase().includes(term)
                );
            }
            
            setTotalCount(filteredData.length);
            
            const start = (currentPage - 1) * pageSize;
            const end = start + pageSize;
            const paginatedData = filteredData.slice(start, end);
            
            setTarefas(paginatedData);
            setError(null);
        } catch (err) {
            setError(`Erro ao processar dados: ${err.message}`);
            console.error('Erro ao processar tarefas:', err);
            setTarefas([]);
        } finally {
            setLoading(false);
        }
    };

    const handleOffCanvasClose = () => {
        setSelectedTarefa(null);
        fetchTarefas();
    };

    const handleStatusChange = (id, newStatus) => {
        const updatedTarefas = tarefas.map(tarefa =>
            tarefa.id === id ? { ...tarefa, status: newStatus } : tarefa
        );
        setTarefas(updatedTarefas);

        if (selectedTarefa && selectedTarefa.id === id) {
            setSelectedTarefa({ ...selectedTarefa, status: newStatus });
        }
        
        const mockIndex = mockTarefas.findIndex(t => t.id === id);
        if (mockIndex !== -1) {
            mockTarefas[mockIndex].status = newStatus;
        }
    };

    const renderizarStatus = (status) => {
        if (status === 'Entregue') {
            return (
            <span className="px-2 py-[0.10rem] inline-flex text-xs leading-5 font-normal rounded-full bg-[#3b82f626] text-[#1d4ed8]">
                    Entregue
                </span>
            );
        } else if (status === 'Pendente') {
            return (
                <span className="px-2 py-[0.10rem] inline-flex text-xs leading-5 font-normal rounded-full bg-[#eab30826] text-[#a16207]">
                    Pendente
                </span>
            );
        }
        return status;
    };

    const renderizarConteudo = (coluna, item) => {
        if (coluna.campo === 'responsavel_nome') {
            const nomeResponsavel = item[coluna.campo] || '';
            const nomeSemId = nomeResponsavel.split('|')[0].trim();
            return nomeSemId;
        } else if (coluna.tipo === 'status') {
            return renderizarStatus(item[coluna.campo]);
        } else if (coluna.campo === 'prazo_legal' || coluna.campo === 'competencia') {
            if (item[coluna.campo]) {
                if (coluna.campo === 'competencia') {
                    const data = new Date(item[coluna.campo]);
                    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
                    const ano = data.getFullYear();
                    return `${mes}/${ano}`;
                } else {
                    const [ano, mes, dia] = item[coluna.campo].split('-');
                    return `${dia}/${mes}/${ano}`;
                }
            }
        } else if (coluna.tipo === 'acoes') {
            return (
                <div className="flex justify-center">
                    <button
                        className="text-gray-500 flex items-center justify-center h-6 w-6 rounded-full hover:bg-gray-100"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleOpenOffCanvas(item);
                        }}
                        title="Visualizar"
                    >
                        <FiEye className="text-gray-600 text-base" />
                    </button>
                </div>
            );
        }
    
        return item[coluna.campo] || '—';
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const totalPages = Math.ceil(totalCount / pageSize);

    return (
        <div>
            <div className="flex justify-between items-center">
                <div className="flex justify-between items-center">
                    <div className='mb-8'>
                        <Input
                            type="text"
                            size="xs"
                            variant="search"
                            value={searchTerm}
                            label="Pesquisar"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>
                <div className="flex items-center">
                    <button className="p-2 text-black hover:bg-gray-100 rounded-full transition-colors duration-200">
                        <FiGitBranch size={16} className='text-[#6b7280]'/>
                    </button>
                </div>
            </div>
            <div>
                {loading ? (
                    <Loader />
                ) : error ? (
                    <div className="text-center text-red-500 py-4">{error}</div>
                ) : (
                    <div>
                        <div className="overflow-x-auto">
                        <Table
                            colunas={colunas}
                            dados={tarefas}
                            renderizarStatus={renderizarStatus}
                            renderizarConteudo={renderizarConteudo}
                            className="cursor-pointer"
                            />
                        </div>

                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                            showPageNumbers={true}
                            maxPageNumbers={5}
                        />
                    </div>
                )}
            </div>

            <RecorrentOffCanvas
                item={selectedTarefa}
                onStatusChange={handleStatusChange}
                onClose={handleOffCanvasClose}
            />
        </div>
    );
};

export default Recorrentes;